module.exports = __webpack_public_path__ + "static/docviser-098592d198623eef66827a1a5681de79.png";